<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<ng-template #windowTitleBar let-win>
  <span class="k-window-title">OPPORTUNITY DETAILS</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<kendo-pdfviewer style="height: 600px;" [saveFileName]="filename" [tools]="tools"  [url]="url" > </kendo-pdfviewer>

